import SampleDetailAdditionalInfo from './CoolantSampleDetailAdditionalInformation.vue';
import SampleDetailBasicInfo from './CoolantSampleDetailBasicInformation.vue';
import SampleDetailBillingInfo from './CoolantSampleDetailBillingInformation.vue';
import SampleDetailHeader from './CoolantSampleDetailHeader.vue';
import SampleDetailPrimaryResults from './CoolantSampleDetailPrimaryResults.vue';
import SampleDetailSecondaryResults from './CoolantSampleDetailSecondaryResults.vue';

export default {
  SampleDetailAdditionalInfo,
  SampleDetailBasicInfo,
  SampleDetailBillingInfo,
  SampleDetailHeader,
  SampleDetailPrimaryResults,
  SampleDetailSecondaryResults
};
